(() => {
  if (customElements.get('gh-jewellery-tray')) return;
  const unifyStraps = (tray) => {
    if (tray.uniformStrapDisplay === 2) return;
    tray.uniformStrapDisplay = 2;
    const sources = new Map(), rendered = new Map();
    const originalLayout = () => {
      if (!tray.dialog.open) return;
      const field=tray.querySelector('[data-tray-field]'),r=field.getBoundingClientRect();
      const scaled=tray.entries.filter(entry=>tray.imageDimensions(entry));
      // Full strap photographs must not shrink every calibrated case.
      const maxHeight=Math.min(68,Math.max(1,...scaled.map(entry=>tray.imageDimensions(entry).height)));
      const maxCase=Math.max(1,...scaled.map(entry=>entry.geometry.caseWidth));
      const scale=Math.min(r.height*.86/maxHeight,r.width*.24/maxCase);
      field.querySelectorAll('.gh-tray-piece').forEach(button=>{
        const entry=tray.entries.find(p=>p.id===button.dataset.pieceId),dimensions=entry && tray.imageDimensions(entry);
        if(!dimensions)return;
        const g=entry.geometry,img=button.querySelector('img');
        button.style.width=Math.max(44,g.caseWidth*scale*1.35)+'px';
        button.style.height=dimensions.height*scale+'px';
        button.dataset.caseWidth=String(g.caseWidth);
        button.dataset.casePixels=String(g.caseWidth*scale);
        img.style.width=dimensions.width*scale+'px';img.style.height=dimensions.height*scale+'px';
        img.style.transform='translate(-'+g.centerX*100+'%,-'+g.centerY*100+'%)';
      });
    };
    const source = (url) => {
      if (sources.has(url)) return sources.get(url);
      const record = {ready:false}; sources.set(url,record);
      const image = new Image(); image.crossOrigin = 'anonymous';
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
          const context = canvas.getContext('2d', {willReadFrequently:true});
          context.drawImage(image,0,0);
          const pixels = context.getImageData(0,0,canvas.width,canvas.height).data;
          let top = canvas.height, bottom = 0;
          for (let y=0;y<canvas.height;y++) {
            let count=0;
            for (let x=0;x<canvas.width;x++) if (pixels[(y*canvas.width+x)*4+3]>40) count++;
            if (count>2) {top=Math.min(top,y);bottom=Math.max(bottom,y+1);}
          }
          if (bottom<=top) return;
          Object.assign(record,{ready:true,image,width:canvas.width,height:canvas.height,top,bottom});
          tray.layoutPieces();
        } catch { record.failed=true; }
      };
      image.onerror = () => {record.failed=true;};
      image.src = url;
      return record;
    };
    tray.layoutPieces = () => {
      originalLayout();
      const field = tray.querySelector('[data-tray-field]');
      if (!field || !tray.dialog.open) return;
      const fieldHeight = field.getBoundingClientRect().height;
      const targetHeight = fieldHeight*.84;
      field.querySelectorAll('.gh-tray-piece').forEach(button => {
        const entry = tray.entries.find(p=>p.id===button.dataset.pieceId);
        const dimensions = entry && tray.imageDimensions(entry);
        const img = button.querySelector('img');
        if (!dimensions || !img) return;
        const g=entry.geometry,asset=source(entry.image);
        if (!asset.ready) return;
        const imageWidth=parseFloat(img.style.width),imageHeight=parseFloat(img.style.height);
        if (!(imageWidth>0 && imageHeight>0)) return;
        const unit=imageHeight/asset.height;
        const center=g.centerY*asset.height;
        const guard=Math.max(g.heightRatio*asset.height*1.12,g.caseRatio*asset.width*1.35);
        const half=guard/2;
        const upper=Math.max(asset.top,center-half),lower=Math.min(asset.bottom,center+half);
        const topLength=upper-asset.top,bottomLength=asset.bottom-lower;
        if (topLength<3 || bottomLength<3 || (lower-upper)*unit>=targetHeight*.95) return;
        const outputHeight=Math.round(targetHeight/unit);
        const topEnd=outputHeight/2-(center-upper);
        const bottomStart=outputHeight/2+(lower-center);
        const clipLongStrap=(asset.bottom-asset.top)*unit>targetHeight;
        const cacheKey=entry.image+'|'+outputHeight+'|'+upper+'|'+lower+'|'+clipLongStrap;
        let url=rendered.get(cacheKey);
        if (!url) {
          const canvas=document.createElement('canvas');canvas.width=asset.width;canvas.height=outputHeight;
          const ctx=canvas.getContext('2d');
          if (clipLongStrap) {
            // Crop the existing pixels; never redraw or stretch the case.
            ctx.drawImage(asset.image,0,center-outputHeight/2,asset.width,outputHeight,0,0,asset.width,outputHeight);
          } else {
          ctx.drawImage(asset.image,0,asset.top,asset.width,topLength,0,0,asset.width,topEnd);
          ctx.drawImage(asset.image,0,upper,asset.width,lower-upper,0,topEnd,asset.width,lower-upper);
          ctx.drawImage(asset.image,0,lower,asset.width,bottomLength,0,bottomStart,asset.width,outputHeight-bottomStart);
          }
          url=canvas.toDataURL('image/png');rendered.set(cacheKey,url);
          if (rendered.size>48) rendered.delete(rendered.keys().next().value);
        }
        img.src=url;
        img.style.height=outputHeight*unit+'px';
        img.style.transform='translate(-'+g.centerX*100+'%,-50%)';
        button.style.height=outputHeight*unit+'px';
        button.dataset.uniformHeight='true';
        button.dataset.strapClipped=String(clipLongStrap);
        button.dataset.protectedCaseHeight=String((lower-upper)*unit);
      });
      tray.dispatchEvent(new CustomEvent('gh-tray-display-ready'));
    };
  };

  class JewelleryTray extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.key = 'gh_jewellery_tray_v1';
      this.messages = JSON.parse(this.querySelector('[data-tray-messages]').textContent);
      this.dialog = this.querySelector('dialog');
      this.root = (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/');
      this.entries = this.readSaved();
      this.persist();
      this.selected = this.entries[0]?.id || null;
      this.status = '';
      this.busy = false;
      this.hidden = false;
      document.addEventListener('click', e => {
        const button = e.target.closest('[data-gh-tray-save]');
        if (!button) return;
        e.preventDefault();
        e.stopPropagation();
        this.saveFromButton(button);
      }, options);
      this.querySelector('[data-tray-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-tray-close]').addEventListener('click', () => this.close(), options);
      this.querySelector('[data-tray-try]').addEventListener('click', () => this.tryOn(), options);
      this.photoButton = this.querySelector('[data-tray-photo-save]');
      this.photoButton.addEventListener('click', () => this.saveTrayPhoto(), options);
      this.dialog.addEventListener('close', () => this.querySelector('[data-tray-open]').setAttribute('aria-expanded','false'), options);
      this.dialog.addEventListener('click', e => {
        if (e.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
        }
        const cart = e.target.closest('[data-tray-cart]');
        if (cart) this.addToCart(cart.dataset.trayCart);
        const move = e.target.closest('[data-tray-move]');
        if (move) this.move(move.dataset.trayMove);
        if (e.target.closest('[data-tray-remove]')) this.remove();
      }, options);
      const handle = this.querySelector('[data-tray-handle]');
      let swipe;
      handle.addEventListener('pointerdown', e => {if(!e.target.closest('button')) swipe={x:e.clientX,y:e.clientY};}, options);
      handle.addEventListener('pointerup', e => {if(swipe && e.clientY-swipe.y>55 && Math.abs(e.clientX-swipe.x)<80) this.close(); swipe=null;}, options);
      window.addEventListener('storage', e => {
        if(e.key!==this.key || this.busy)return;
        const previous=this.entries;
        this.entries=this.readSaved().map(entry=>{
          const known=previous.find(p=>p.id===entry.id);
          if(!entry.geometry && known?.geometry){entry.geometry=known.geometry;entry.image=known.image;entry.cutout=known.cutout;}
          return entry;
        });
        this.selected=this.entries.some(p=>p.id===this.selected)?this.selected:this.entries[0]?.id||null;
        this.render();this.updateSaveButtons(false);
        if(this.dialog.open)this.refresh(false);
      },options);
      this.observer = new MutationObserver(() => this.updateSaveButtons());
      this.observer.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
      this.resizeObserver = new ResizeObserver(() => this.layoutPieces());
      this.resizeObserver.observe(this.querySelector('[data-tray-field]'));
      unifyStraps(this);
      this.render();
      this.updateSaveButtons();
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.controller=null;}
    message(key) {return this.messages[key] || '';}
    safeImage(value) {
      try {const u=new URL(value,location.origin);return u.protocol==='https:' && (u.origin===location.origin || u.hostname==='cdn.shopify.com') ? u.href : '';}catch{return '';}
    }
    geometry(value) {
      try {
        const g=typeof value==='string'?JSON.parse(value):value;
        if(!g || g.version!==1)return null;
        const number=(v,min,max)=>Number.isFinite(Number(v)) && Number(v)>=min && Number(v)<=max ? Number(v) : 0;
        const caseWidth=number(g.caseWidth,5,100),caseRatio=number(g.caseRatio,.02,1);
        const imageWidth=number(g.imageWidth,1,30000),imageHeight=number(g.imageHeight,1,30000);
        const center=(v)=>Number.isFinite(Number(v)) && Number(v)>0 && Number(v)<1 ? Number(v) : .5;
        return {version:1,scaled:g.scaled===true && !!caseWidth && !!caseRatio && !!imageWidth && !!imageHeight,caseWidth,caseRatio,caseLength:number(g.caseLength,5,120),heightRatio:number(g.heightRatio,.02,1),imageWidth,imageHeight,centerX:center(g.centerX),centerY:center(g.centerY)};
      }catch{return null;}
    }
    isStrap(value) {
      const ids=['9298356568280','9389526221016','9393357979864','9393375281368','9395018498264','9395212189912'];
      return !!value && (ids.includes(String(value.id)) || /strap/i.test([value.productType,value.product_type,value.type].filter(Boolean).join(' ')) || /strap/i.test(value.template || '') || /(?:watch[- ]?strap|hirsch-(?:rainbow|kansas|osiris|lizard))/i.test(value.handle || '') || /\bwatch straps?\b/i.test(value.title || ''));
    }
    removeStrap(entry) {
      this.entries=this.entries.filter(p=>p.id!==entry.id);
      if(this.selected===entry.id)this.selected=this.entries[0]?.id || null;
    }
    sanitise(value) {
      if (this.isStrap(value) || !value || !/^\d+$/.test(String(value.id)) || !/^[a-z0-9][a-z0-9-]*$/.test(value.handle || '') || typeof value.title!=='string') return null;
      return {id:String(value.id),productType:String(value.productType || value.product_type || '').slice(0,150),template:String(value.template || '').slice(0,100),handle:value.handle,title:value.title.slice(0,300),image:this.safeImage(value.image),cutout:value.cutout===true,geometry:this.geometry(value.geometry),available:value.available===true,direct:value.direct===true,variant:/^\d+$/.test(String(value.variant))?String(value.variant):'',price:Math.max(0,Number(value.price)||0),x:Math.max(15,Math.min(85,Number(value.x)||50)),y:Math.max(25,Math.min(75,Number(value.y)||50)),verified:false,checking:false};
    }
    readSaved() {
      try {const items=JSON.parse(localStorage.getItem(this.key)||'[]');return Array.isArray(items)?items.map(v=>this.sanitise(v)).filter(Boolean).filter((v,i,a)=>a.findIndex(x=>x.id===v.id)===i).slice(0,6):[];}catch{return [];}
    }
    persist() {
      try {localStorage.setItem(this.key,JSON.stringify(this.entries.map(({verified,checking,missing,...entry})=>entry)));}catch{this.querySelector('[data-tray-announcement]').textContent=this.message('storage');}
      document.dispatchEvent(new CustomEvent('gh-tray-updated'));
    }
    updateSaveButtons(persist=true) {
      let changed=false;
      document.querySelectorAll('[data-gh-tray-save]').forEach(button => {
        if(this.isStrap(button.dataset)){button.hidden=true;return;}
        const entry=this.entries.find(p=>p.id===button.dataset.id);
        const saved=!!entry;
        const geometry=this.geometry(button.dataset.geometry);
        if(entry && geometry && JSON.stringify(entry.geometry)!==JSON.stringify(geometry)){
          entry.geometry=geometry;entry.image=this.safeImage(button.dataset.image);entry.cutout=button.dataset.cutout==='true';changed=true;
        }
        const label=this.message(saved?'saved':'save');
        button.hidden=false;
        const text=button.querySelector('[data-tray-button-label]') || button;
        if(text.textContent!==label) text.textContent=label;
        button.setAttribute('aria-pressed',String(saved));
      });
      if(changed){if(persist)this.persist();this.render();}
    }
    saveFromButton(button) {
      if(this.isStrap(button.dataset))return;
      const existing=this.entries.find(p=>p.id===button.dataset.id);
      if(existing){this.selected=existing.id;this.open();return;}
      if(this.entries.length>=6){this.status=this.message('limit');this.open();return;}
      const value=this.sanitise({...button.dataset,cutout:button.dataset.cutout==='true',available:button.dataset.available==='true',direct:button.dataset.direct==='true',x:[24,50,76,32,68,24,50,76][this.entries.length],y:[50,50,50,34,34,68,68,68][this.entries.length]});
      if(!value)return;
      this.entries.push(value);this.selected=value.id;this.persist();this.render();this.updateSaveButtons();
      this.querySelector('[data-tray-announcement]').textContent=this.message('added');
      window.ghWatchAnalytics?.track('gh_tray_add', {watch_id:value.id,watch_name:value.title,watch_handle:value.handle});
    }
    open() {
      this.render();
      if(!this.dialog.open)this.dialog.showModal();
      this.layoutPieces();
      this.querySelector('[data-tray-open]').setAttribute('aria-expanded','true');
      this.refresh();
    }
    close() {this.dialog.close();}
    async tryOn() {
      const candidates = [
        ...this.entries.filter(p => p.id === this.selected && p.cutout),
        ...this.entries.filter(p => p.id !== this.selected && p.cutout)
      ];
      if (!candidates.length) return;
      const button = this.querySelector('[data-tray-try]');
      button.disabled = true;
      this.status = 'Opening wrist preview…';
      this.render();
      try {
        const preview = document.querySelector('gh-tray-wrist-preview');
        if (preview) {
          this.close();
          preview.openFromTray(candidates[0].id);
          return;
        }
        for (const entry of candidates) {
          const url = new URL(this.root + 'products/' + encodeURIComponent(entry.handle), location.origin);
          const previewId = new URLSearchParams(location.search).get('preview_theme_id');
          if (/^\d+$/.test(previewId || '')) url.searchParams.set('preview_theme_id', previewId);
          try {
            const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
            if (!response.ok) continue;
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (!page.querySelector('gh-wrist-preview[data-product-id="' + entry.id + '"]')) continue;
            sessionStorage.setItem('gh_tray_ar_autostart', JSON.stringify({id:entry.id,at:Date.now()}));
            location.assign(url.href);
            return;
          } catch {}
        }
        this.status = 'Wrist preview is unavailable for the watches in your tray.';
      } finally {
        button.disabled = false;
        this.render();
      }
    }
    async request(url,options={}) {
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000),...options});
      const body=await response.json();
      if(!response.ok)throw new Error(body.description || body.message || this.message('cart_error'));
      return body;
    }
    async check(entry,persist=true) {
      entry.checking=true;entry.verified=false;this.render();
      try {
        const p=await this.request(this.root+'products/'+encodeURIComponent(entry.handle)+'.js');
        if(String(p.id)!==entry.id)throw new Error('Unavailable');
        if(this.isStrap(p)){this.removeStrap(entry);return false;}
        entry.productType=p.type || p.product_type || entry.productType;
        entry.available=p.available===true;
        entry.title=String(p.title || entry.title);
        entry.price=Math.max(0,Number(p.price)||0);
        const variant=p.variants?.find(v=>v.available);
        entry.variant=variant?String(variant.id):'';
        entry.direct=entry.direct && p.variants?.length===1 && !p.requires_selling_plan;
        entry.verified=true;entry.missing=false;
        await this.loadGeometry(entry);
      }catch{entry.verified=false;entry.missing=true;}
      finally{entry.checking=false;if(persist)this.persist();this.render();}
      return entry.verified;
    }
    async loadGeometry(entry) {
      try {
        const response=await fetch(this.root+'products/'+encodeURIComponent(entry.handle)+'?view=gh-tray',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
        if(!response.ok)return;
        const markup=new DOMParser().parseFromString(await response.text(),'text/html');
        const button=markup.querySelector('[data-gh-tray-save]');
        if(!button || button.dataset.id!==entry.id)return;
        const geometry=this.geometry(button.dataset.geometry);
        if(geometry){entry.geometry=geometry;entry.image=this.safeImage(button.dataset.image);entry.cutout=button.dataset.cutout==='true';}
      }catch{}
    }
    imageDimensions(entry) {
      const g=entry.geometry;
      if(!entry.cutout || !g?.scaled)return null;
      const width=g.caseWidth/g.caseRatio;
      const height=width*g.imageHeight/g.imageWidth;
      return {width,height};
    }
    layoutPieces() {
      if(!this.dialog.open)return;
      const field=this.querySelector('[data-tray-field]'),r=field.getBoundingClientRect();
      const scaled=this.entries.filter(entry=>this.imageDimensions(entry));
      const maxHeight=Math.max(1,...scaled.map(entry=>this.imageDimensions(entry).height));
      const maxCase=Math.max(1,...scaled.map(entry=>entry.geometry.caseWidth));
      const scale=Math.min(r.height*.86/maxHeight,r.width*.24/maxCase);
      field.querySelectorAll('.gh-tray-piece').forEach(button=>{
        const entry=this.entries.find(p=>p.id===button.dataset.pieceId),dimensions=entry && this.imageDimensions(entry);
        if(!dimensions)return;
        const g=entry.geometry,img=button.querySelector('img');
        button.style.width=Math.max(44,g.caseWidth*scale*1.35)+'px';
        button.style.height=dimensions.height*scale+'px';
        button.dataset.caseWidth=String(g.caseWidth);
        button.dataset.casePixels=String(g.caseWidth*scale);
        img.style.width=dimensions.width*scale+'px';img.style.height=dimensions.height*scale+'px';
        img.style.transform='translate(-'+g.centerX*100+'%,-'+g.centerY*100+'%)';
      });
    }
    async saveTrayPhoto() {
      if(this.photoBusy || !this.entries.length || !this.dialog.open)return;
      this.photoBusy=true;this.photoButton.disabled=true;
      this.status=this.message('photo_saving');
      this.querySelector('[data-tray-status]').textContent=this.status;
      try{
        const tray=this.querySelector('.gh-tray-silver');
        const bounds=tray.getBoundingClientRect();
        const items=Array.from(tray.querySelectorAll('.gh-tray-piece')).map(button=>{
          const image=button.querySelector('img');
          if(!image)throw new Error('Missing tray image');
          const badge=button.querySelector('.gh-tray-sold'),badgeStyle=badge && getComputedStyle(badge);
          return {src:image.currentSrc || image.src,imageRect:image.getBoundingClientRect(),fit:getComputedStyle(image).objectFit,badge:badge ? {rect:badge.getBoundingClientRect(),text:badge.textContent,background:badgeStyle.backgroundColor,border:badgeStyle.borderColor,font:badgeStyle.font,color:badgeStyle.color} : null};
        });
        const load=async src=>{const image=new Image();image.crossOrigin='anonymous';image.src=src;await image.decode();return image;};
        const images=await Promise.all(items.map(item=>load(item.src)));
        const style=getComputedStyle(tray),inner=getComputedStyle(tray,'::before');
        const radius=parseFloat(style.borderRadius),inset=parseFloat(inner.left),innerRadius=parseFloat(inner.borderRadius);
        const engraving=tray.querySelector('.gh-tray-engraving svg').cloneNode(true);
        engraving.setAttribute('x','0');engraving.setAttribute('y','0');
        engraving.setAttribute('width',String(bounds.width));engraving.setAttribute('height',String(bounds.height));
        engraving.setAttribute('stroke','#777d6c');engraving.setAttribute('opacity',getComputedStyle(tray.querySelector('.gh-tray-engraving')).opacity);
        const decoration=new XMLSerializer().serializeToString(engraving);
        const w=bounds.width,h=bounds.height;
        const background='<svg xmlns="http://www.w3.org/2000/svg" width="'+w+'" height="'+h+'" viewBox="0 0 '+w+' '+h+'"><defs><linearGradient id="gh-photo-metal" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#e8e6df"/><stop offset=".08" stop-color="#b9bab5"/><stop offset=".18" stop-color="#fbfaf5"/><stop offset=".32" stop-color="#d4d4cc"/><stop offset=".57" stop-color="#f0eee7"/><stop offset=".83" stop-color="#bcbeb8"/><stop offset=".94" stop-color="#f4f2ec"/><stop offset="1" stop-color="#a5a8a1"/></linearGradient><linearGradient id="gh-photo-inner"><stop stop-color="#e0e1d9"/><stop offset=".35" stop-color="#eeeee7"/><stop offset=".75" stop-color="#d7d9d0"/><stop offset="1" stop-color="#e8e8df"/></linearGradient></defs><rect x=".5" y=".5" width="'+(w-1)+'" height="'+(h-1)+'" rx="'+radius+'" fill="url(#gh-photo-metal)" stroke="#92968c"/><rect x="3" y="3" width="'+(w-6)+'" height="'+(h-6)+'" rx="'+Math.max(0,radius-3)+'" fill="none" stroke="#f8f7ef" stroke-width="2" opacity=".7"/><rect x="6" y="6" width="'+(w-12)+'" height="'+(h-12)+'" rx="'+Math.max(0,radius-6)+'" fill="none" stroke="#787e70" opacity=".25"/><rect x="'+inset+'" y="'+inset+'" width="'+(w-inset*2)+'" height="'+(h-inset*2)+'" rx="'+innerRadius+'" fill="url(#gh-photo-inner)" stroke="#82897a" stroke-opacity=".35"/>'+decoration+'</svg>';
        const silver=await load('data:image/svg+xml;charset=utf-8,'+encodeURIComponent(background));
        const canvas=document.createElement('canvas');canvas.width=1600;canvas.height=Math.round(1600*h/w);
        const ctx=canvas.getContext('2d'),scale=canvas.width/w;
        ctx.scale(scale,scale);
        ctx.beginPath();ctx.roundRect(0,0,w,h,radius);ctx.clip();
        ctx.drawImage(silver,0,0,w,h);
        items.forEach((item,index)=>{
          const image=images[index],r=item.imageRect;
          let width=r.width,height=r.height;
          if(item.fit==='contain'){
            const ratio=Math.min(width/image.naturalWidth,height/image.naturalHeight);
            width=image.naturalWidth*ratio;height=image.naturalHeight*ratio;
          }
          const x=r.left-bounds.left+(r.width-width)/2,y=r.top-bounds.top+(r.height-height)/2;
          ctx.save();ctx.shadowColor='rgba(57,53,26,.19)';ctx.shadowBlur=3;ctx.shadowOffsetX=2;ctx.shadowOffsetY=5;
          ctx.drawImage(image,x,y,width,height);ctx.restore();
          if(item.badge){
            const badge=item.badge.rect;
            ctx.fillStyle=item.badge.background;ctx.strokeStyle=item.badge.border;
            ctx.beginPath();ctx.roundRect(badge.left-bounds.left,badge.top-bounds.top,badge.width,badge.height,Math.min(14,badge.height/2));ctx.fill();ctx.stroke();
            ctx.font=item.badge.font;ctx.fillStyle=item.badge.color;ctx.textAlign='center';ctx.textBaseline='middle';
            ctx.fillText(item.badge.text,badge.left-bounds.left+badge.width/2,badge.top-bounds.top+badge.height/2);
          }
        });
        const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
        if(!blob)throw new Error('Tray export failed');
        const url=URL.createObjectURL(blob),link=document.createElement('a');
        link.href=url;link.download='gilded-hour-my-tray.png';document.body.append(link);link.click();link.remove();
        setTimeout(()=>URL.revokeObjectURL(url),60000);
        this.status=this.message('photo_saved');
      }catch{this.status=this.message('photo_failed');}
      finally{
        this.photoBusy=false;this.photoButton.disabled=!this.entries.length;
        this.querySelector('[data-tray-status]').textContent=this.status;
      }
    }
    async refresh(persist=true) {
      await Promise.allSettled(this.entries.filter(p=>!p.checking).map(p=>this.check(p,persist)));
    }
    formatPrice(price) {
      try{return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ',{style:'currency',currency:window.Shopify?.currency?.active || this.dataset.currency || 'NZD',maximumFractionDigits:2}).format(price/100);}catch{return '';}
    }
    node(tag,className,text) {const n=document.createElement(tag);if(className)n.className=className;if(text!==undefined)n.textContent=text;return n;}
    productLink(entry,label) {const a=this.node('a','',label);a.href=this.root+'products/'+encodeURIComponent(entry.handle);return a;}
    render() {
      const focusId=this.dialog.querySelector('.gh-tray-piece:focus')?.dataset.pieceId;
      this.querySelector('[data-tray-count]').textContent=this.entries.length;
      this.querySelector('[data-tray-empty]').hidden=this.entries.length>0;
      this.photoButton.disabled=this.photoBusy || !this.entries.length;
      this.querySelector('[data-tray-try]').hidden=!this.entries.some(p=>p.cutout);
      const field=this.querySelector('[data-tray-field]');field.replaceChildren();
      for(const entry of this.entries) {
        const scaled=!!this.imageDimensions(entry);
        const button=this.node('button','gh-tray-piece'+(scaled?' gh-tray-scaled':entry.cutout?'':' gh-tray-photo'));button.type='button';button.dataset.pieceId=entry.id;
        button.style.left=entry.x+'%';button.style.top=entry.y+'%';
        button.setAttribute('aria-pressed',String(entry.id===this.selected));
        button.setAttribute('aria-label',this.message(entry.available?'select':'select_sold')+' '+entry.title);
        if(entry.image){const img=this.node('img');img.src=entry.image;img.alt='';img.width=entry.geometry?.imageWidth || 180;img.height=entry.geometry?.imageHeight || 260;img.draggable=false;button.append(img);}
        else button.append(this.node('span','',entry.title));
        if(!entry.available)button.append(this.node('span','gh-tray-sold',this.message('sold_out')));
        let drag;
        button.addEventListener('pointerdown',e=>{if(e.button!==0)return;drag={x:e.clientX,y:e.clientY,px:entry.x,py:entry.y};button.setPointerCapture(e.pointerId);});
        button.addEventListener('pointermove',e=>{if(!drag)return;const r=field.getBoundingClientRect();entry.x=Math.max(15,Math.min(85,drag.px+(e.clientX-drag.x)/r.width*100));entry.y=Math.max(25,Math.min(75,drag.py+(e.clientY-drag.y)/r.height*100));button.style.left=entry.x+'%';button.style.top=entry.y+'%';});
        button.addEventListener('pointerup',()=>{drag=null;this.selected=entry.id;this.persist();this.render();});
        button.addEventListener('pointercancel',()=>{drag=null;this.persist();});
        button.addEventListener('click',()=>{this.selected=entry.id;this.render();});
        button.addEventListener('keydown',e=>{const d={ArrowLeft:'left',ArrowRight:'right',ArrowUp:'up',ArrowDown:'down'}[e.key];if(d){e.preventDefault();this.selected=entry.id;this.move(d);}});
        field.append(button);
      }
      const selection=this.querySelector('[data-tray-selection]');selection.replaceChildren();
      const entry=this.entries.find(p=>p.id===this.selected);
      this.querySelector('[data-tray-tools]').hidden=!entry;
      if(entry) {
        const copy=this.node('div','gh-tray-copy');copy.append(this.node('strong','',entry.title));
        if(entry.checking)copy.append(this.node('small','',this.message('checking')));
        else if(!entry.verified)copy.append(this.node('small','',this.message('unavailable')));
        if(!entry.available)copy.append(this.node('span','gh-tray-sold',this.message('sold_out')));
        else if(entry.verified)copy.append(this.node('small','',this.formatPrice(entry.price)));
        if(entry.geometry?.caseWidth)copy.append(this.node('small','gh-tray-case',this.message('case_size')+': '+entry.geometry.caseWidth+' mm'));
        if(!this.imageDimensions(entry))copy.append(this.node('small','gh-tray-scale-note',this.message(entry.cutout?'unscaled':'photo_scale')));
        const actions=this.node('div','gh-tray-actions');
        if(entry.available && entry.direct) {
          const cart=this.node('button','gh-tray-cart',this.message(this.busy?'cart_busy':'cart_add'));cart.type='button';cart.dataset.trayCart=entry.id;cart.disabled=this.busy || !entry.verified || entry.checking;actions.append(cart);
        }
        actions.append(this.productLink(entry,this.message(entry.available && !entry.direct?'options':'view')+' →'));
        selection.append(copy,actions);
      }
      this.querySelector('[data-tray-status]').textContent=this.status;
      this.layoutPieces();
      if(focusId)field.querySelector('[data-piece-id="'+focusId+'"]')?.focus({preventScroll:true});
    }
    move(direction) {
      const entry=this.entries.find(p=>p.id===this.selected);if(!entry)return;
      entry.x=Math.max(15,Math.min(85,entry.x+(direction==='left'?-5:direction==='right'?5:0)));
      entry.y=Math.max(25,Math.min(75,entry.y+(direction==='up'?-5:direction==='down'?5:0)));
      this.persist();this.render();
    }
    remove() {
      if(this.busy)return;
      this.entries=this.entries.filter(p=>p.id!==this.selected);this.selected=this.entries[0]?.id || null;
      this.status=this.message('removed');this.persist();this.render();this.updateSaveButtons();
    }
    async addToCart(id) {
      const entry=this.entries.find(p=>p.id===id);if(!entry || this.busy || !entry.available || !entry.direct)return;
      this.busy=true;this.status='';this.render();
      try {
        if(!await this.check(entry) || !entry.available || !entry.direct || !entry.variant)throw new Error(this.message('cart_error'));
        const current=await this.request(this.root+'cart.js');
        if(current.items.some(item=>String(item.variant_id)===entry.variant)){this.status=this.message('cart_added');return;}
        const cart=document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections=cart?.getSectionsToRender?.().map(s=>s.id) || ['cart-icon-bubble'];
        const result=await this.request(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:entry.variant,quantity:1}],sections:sections.slice(0,5),sections_url:location.pathname})});
        this.status=this.message('cart_added');
        if(cart?.renderContents){this.close();cart.classList.remove('is-empty');cart.renderContents({...result.items[0],sections:result.sections});}
        else if(result.sections?.['cart-icon-bubble']){const html=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');const content=html.querySelector('#cart-icon-bubble')?.innerHTML || html.querySelector('.shopify-section')?.innerHTML;const icon=document.getElementById('cart-icon-bubble');if(icon && content)icon.innerHTML=content;}
      }catch(error){this.status=error.message || this.message('cart_error');await this.check(entry);}
      finally{this.busy=false;this.render();}
    }
  }
  customElements.define('gh-jewellery-tray',JewelleryTray);
})();


(() => {
  if (window.ghTrayReporter) return;
  const ENABLED = true;
  const ENDPOINT = 'https://gilded-hour-tray-collector.weyta-widjaja.chatgpt.site/api/collect';
  const KEY = 'gh_tray_reporting_identity_v1';
  const TRAY_KEY = 'gh_jewellery_tray_v1';
  let timer, retryTimer, sending = false, pending = false, last = '', attempts = 0, revision = 0;
  const preview = () => window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || (window.Shopify?.theme?.role && window.Shopify.theme.role.toLowerCase() !== 'main');
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const identity = (create = true) => {
    try {
      const old = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (old && /^[0-9a-f-]{36}$/.test(old.visitorId) && /^[0-9a-f]{64}$/.test(old.token)) return old;
      if (!create) return null;
      const value = { visitorId: crypto.randomUUID(), token: Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2,'0')).join('') };
      localStorage.setItem(KEY, JSON.stringify(value)); return value;
    } catch { return null; }
  };
  const snapshot = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(TRAY_KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.slice(0,6).filter(w => w && /^\d+$/.test(String(w.id)) && /^[a-z0-9][a-z0-9-]*$/.test(w.handle || '') && typeof w.title === 'string').map(w => ({ id:String(w.id), handle:w.handle, title:w.title.slice(0,300), image:String(w.image || '').slice(0,1800), price:Math.max(0, Number(w.price) || 0), available:w.available === true }));
    } catch { return []; }
  };
  const send = async () => {
    if (!ENABLED || preview() || !allowed()) return;
    if (sending) { pending = true; return; }
    const items = snapshot(), signature = JSON.stringify(items), known = identity(false);
    if (signature === last || (!items.length && !known)) return;
    const visitor = known || identity(); if (!visitor) return;
    revision = Math.max(Date.now(), revision + 1);
    sending = true;
    try {
      const res = await fetch(ENDPOINT, { method:'POST', headers:{'Content-Type':'text/plain;charset=UTF-8'}, body:JSON.stringify({...visitor,items,revision}), credentials:'omit', keepalive:true, signal:AbortSignal.timeout(8000) });
      if (!res.ok) throw Error('Update unavailable');
      last = signature; attempts = 0;
    } catch {
      if (attempts < 3) { attempts++; clearTimeout(retryTimer); retryTimer = setTimeout(send, Math.min(30000, attempts * 6000)); }
    } finally { sending = false; if (pending) { pending = false; notify(); } }
  };
  const notify = () => { if (!ENABLED || preview() || !allowed()) return; clearTimeout(timer); timer = setTimeout(send,700); };
  const privacyChanged = () => {
    if (!ENABLED || preview()) return;
    if (allowed()) { notify(); return; }
    clearTimeout(timer); clearTimeout(retryTimer);
    const visitor = identity(false); if (!visitor) return;
    fetch(ENDPOINT, {method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({...visitor,action:'forget'}),credentials:'omit',keepalive:true}).then(res => {if(res.ok){localStorage.removeItem(KEY);last='';}}).catch(()=>{});
  };
  window.ghTrayReporter = { notify };
  document.addEventListener('gh-tray-updated', notify);
  document.addEventListener('visitorConsentCollected', privacyChanged);
  window.addEventListener('storage', e => { if (e.key === TRAY_KEY) notify(); });
  window.addEventListener('online', notify);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) notify(); });
  if (ENABLED && !preview()) {
    if (window.Shopify?.customerPrivacy) privacyChanged();
    else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) privacyChanged();});
  }
})();
